import HttpClient from './utils/HttpClient';

class LogsService {
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_API_URL);
  }

  createLog(name, message, error) {
    return this.httpClient.post('v1/errors/front_end', {
      body: {
        DeName: name,
        DeMessage: message,
        DeError: error?.stack,
        DeAplication: 'resultados-exames',
        CdTennant: process.env.REACT_APP_API_COD_BANCO,
      },
      headers: {
        codBanco: 'cliente',
      },
    });
  }
}

export default new LogsService();
